import { Box, Stack } from '@mui/material'

const ValidationErrors = (props: { messages: string[] }) => {
    return (
        <Stack
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            gap={1}
            style={{ marginTop: '2rem' }}
        >
            <Box style={{ color: 'red' }}>
                <b>Errors:</b>
            </Box>
            {props.messages.map((failureMessage) => {
                return <Box style={{ textAlign: 'left' }}>{failureMessage}</Box>
            })}
        </Stack>
    )
}

export default ValidationErrors
